import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetDepreciationReport  {
    _originalTypeClassName = "zERP.BO.AssetDepreciationReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetDepreciationReport.translate = translateService;
}
this.Assets = [];
this.DateFrom = null;
this.DateTo = null;
this.AssetDepreciationReportKey = null;
this._key = this.AssetDepreciationReportKey = 0; 
}

static translate: TranslateService;
_key: any;
DateFrom:any;
DateTo:any;
Assets:any;
private _AssetDepreciationReportKey:any;
get AssetDepreciationReportKey(): any {
    return this._AssetDepreciationReportKey;
  }
set AssetDepreciationReportKey(value: any) {
    this._AssetDepreciationReportKey = value;
    this._key = value;
  }
static setAssets = ($this, items) => {
                if (items == null) items = [];
                if ($this.Assets == null) $this.Assets = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Assets.length > 0) {
                    Domain.AssetDepreciationReport.removeAssets($this, $this.Assets[0]);
                }

                Domain.AssetDepreciationReport.addManyAssets($this, copyItems);
            }
static addManyAssets = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssetDepreciationReport.addAssets($this, items[i]);
                }
            }
static addAssets = ($this, item) => {
                if ($this.Assets == null) $this.Assets = [];
                if (item == null || $this.Assets.indexOf(item) > -1) return;
                $this.Assets.push(item);
}
static addRangeAssets = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssetDepreciationReport.addAssets($this, item));
            }
static removeAssets = ($this, item) => {
                if ($this == null || $this.Assets == null || $this.Assets.indexOf(item) === -1) return;
                var _index = $this.Assets.indexOf(item);
                $this.Assets.splice(_index, 1);
}
static clearAssets = ($this) => { $this.Assets = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetDepreciationReportKey == null || $this.AssetDepreciationReportKey == 0;
            }


}